export const searchOrderCardInputs = [
    {
        label: "프로젝트 코드",
        key: "projectCode",
        type: "auto",
        col: "12",
        sm: "4",
        lg: "3",
        list: [],
        value: "",
        clearable: true,
    },
    {
        label: "관리코드",
        key: "productCode",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "제품명",
        key: "name",
        col: "12",
        sm: "4",
        lg: "2",
        value: "",
        clearable: true,
    },
];
export const orderProductSearchHeaders = [
    { text: "", value: "expander", width: 18, sortable: false },
    {
        text: "프로젝트 코드/입고일자",
        align: "center",
        value: "projectCodeAndInboundDate",
    },
    { text: "종류", align: "center", value: "type" },
    { text: "분류", align: "center", value: "classification" },
    { text: "관리코드", align: "center", value: "productCode" },
    { text: "제품명", align: "center", value: "name" },
    { text: "규격", align: "center", value: "spec" },
    { text: "모델명", align: "center", value: "model" },
    { text: "제조사/입고장소", align: "center", value: "manufacturerAndSpot" },
    {
        text: "발주수량/입고수량",
        align: "center",
        value: "purchaseAndInboundNum",
    },
    {
        text: "진행 현황(완료·대기·남음)/상태",
        align: "center",
        value: "progressAndConditions",
    },
    { text: "입고단가", align: "start", value: "unitPrice" },
    { text: "추가", align: "center", value: "actions" },
];
